import { render } from "./DepositNft.vue?vue&type=template&id=4ff48631&scoped=true"
import script from "./DepositNft.vue?vue&type=script&lang=js"
export * from "./DepositNft.vue?vue&type=script&lang=js"

import "@/Common/Styles/depositNft.scss?vue&type=style&index=0&id=4ff48631&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ff48631"]])

export default __exports__